import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import FormatIcons from "../_components/FormatIcons";
import "../css/style.css";
import "../css/constructor.css";
import DeleteIcon from "@material-ui/icons/Delete";
import MoreIcon from "@material-ui/icons/MoreHoriz";
import SaveIcon from "@material-ui/icons/Save";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@material-ui/icons/Edit";
import Fade from "@mui/material/Fade";
import SelectSpeaker from "./SelectSpeaker";
import SelectRoom from "./SelectRoom";
import SelectTheme from "./SelectTheme";

const STATUS_INVITED = "invited";
const STATUS_APPROVED = "approved";
const STATUS_DECLINED = "declined";
const STATUS_CONTRACT_SENT = "contract_sent";
const STATUS_CONTRACT_SIGNED = "contract_signed";
const STATUS_ACT_SIGNED = "act_signed";
const STATUS_WAITING_FOR_PAYMENT = "waiting_for_payment";
const STATUS_PAID = "paid";

function getFormat(tp) {
  if (!tp || tp == "offline") return "оффлайн";
  if (tp == "online") return "онлайн";

  return "гибрид";
}

function SpeakersList(props) {
  const {
    speakers,
    mainIndex,
    index,
    delSpeaker,
    addSpeaker,
    allSpeakers,
    onSpeakerTextChange,
    onSpeakerContractChange,
    onSpeakerPartipChange,
    saveTime,
    item,
    showDeclined,
  } = props;

  const filteredSpeakers = [];

  for (let i = 0; i < allSpeakers.length; i++) {
    let isAdded = false;
    for (let j = 0; j < speakers.length; j++) {
      if (speakers[j].name == allSpeakers[i]) {
        isAdded = true;
        break;
      }
    }
    if (isAdded == false) {
      filteredSpeakers.push(allSpeakers[i]);
    }
  }

  if (item.entity && item.entity.id)
    return (
      <ul className="speakers-list">
        {speakers
          .filter((e) => showDeclined || e.status != STATUS_DECLINED)
          .map((item, indexSpeaker) => {
            let iName = "";
            if (item && item.name) iName = item.name;

            return (
              <li>
                <Droppable
                  droppableId={`speaker_${mainIndex}_${index}_${indexSpeaker}`}
                >
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="speaker-choose"
                    >
                      <SelectSpeaker
                        data={filteredSpeakers}
                        item={iName}
                        onChange={(e) => onSpeakerTextChange(e, indexSpeaker)}
                      />
                    </div>
                  )}
                </Droppable>
                {iName != "" && (
                  <div
                    className="calendar-block__col status-speaker"
                    title="Выбор статуса участия"
                  >
                    <span>Участие</span>

                    <select
                      className="calendar-block__select"
                      onChange={(e) => onSpeakerPartipChange(e, indexSpeaker)}
                    >
                      {item.status == "1" ? (
                        <option value="1" selected>
                          не выбрано
                        </option>
                      ) : (
                        <option value="1">не выбрано</option>
                      )}
                      {item.status == STATUS_INVITED ? (
                        <option value={STATUS_INVITED} selected>
                          участие запрошено
                        </option>
                      ) : (
                        <option value={STATUS_INVITED}>
                          участие запрошено
                        </option>
                      )}
                      {item.status == STATUS_DECLINED ? (
                        <option value={STATUS_DECLINED} selected>
                          участие отклонено
                        </option>
                      ) : (
                        <option value={STATUS_DECLINED}>
                          участие отклонено
                        </option>
                      )}
                      {item.status == "approved" ? (
                        <option value="approved" selected>
                          участие подтверждено
                        </option>
                      ) : (
                        <option value="approved">участие подтверждено</option>
                      )}
                      {item.status == "without_contract" ? (
                        <option value="approved" selected>
                          договор не нужен
                        </option>
                      ) : (
                        <option value="approved">договор не нужен</option>
                      )}

                      {item.status == "contract_sent" ? (
                        <option value="contract_sent" selected>
                          договор направлен
                        </option>
                      ) : (
                        <option value="contract_sent">договор направлен</option>
                      )}
                      {item.status == "act_signed" ? (
                        <option value="act_signed" selected>
                          акт подписан
                        </option>
                      ) : (
                        <option value="act_signed">акт подписан</option>
                      )}
                      {item.status == "waiting_for_payment" ? (
                        <option value="waiting_for_payment" selected>
                          в оплате
                        </option>
                      ) : (
                        <option value="waiting_for_payment">в оплате</option>
                      )}
                      {item.status == "paid" ? (
                        <option value="paid" selected>
                          оплачен
                        </option>
                      ) : (
                        <option value="paid">оплачен</option>
                      )}
                    </select>
                  </div>
                )}

                <div
                  className="addSpeaker"
                  onClick={() => addSpeaker(index, mainIndex)}
                >
                  <i className="icon-plus-border" />
                </div>
              </li>
            );
          })}
      </ul>
    );

  return null;
}

export default function SlotItem(props) {
  const {
    item,
    index,
    mainIndex,
    delTheme,
    delRoom,
    delSpeaker,
    themes,
    rooms,
    changeThemes,
    changeRoom,
    delSlot,
    unbindSlot,
    addSpeaker,
    changeSpeakers,
    speakers,
    changeSpeakerPartip,
    saveTime,
    changeMode,
    saveUrl,
    moveSlot,
    plusDuration,
    minusDuration,
    showDeclined,
    editTheme,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const [focus, setFocus] = React.useState(false);
  const [focusUrl, setFocusUrl] = React.useState(false);
  const [startTime, setTime] = React.useState(null);
  const [oldTime, setOldTime] = React.useState(null);
  const [oldDur, setOldDur] = React.useState(null);
  const [oldUrl, setOldUrl] = React.useState(null);
  const [duration, setDuration] = React.useState(null);
  const [url, setUrl] = React.useState(null);
  const [count, setCount] = React.useState(0);
  const [id, setId] = React.useState(null);

  React.useEffect(() => {
    if (count == 0) {
      setId(item.id);

      if (item.url_online) {
        setUrl(item.url_online);
      } else setUrl("");

      setTime(item.start_time ? item.start_time : "");
      setDuration(item.duration ? item.duration : "");
      setCount(1);
    }

    if (count > 0 && item.id != id) {
      //setTime(item.start_time ? item.start_time : "");
      //setUrl(item.url_online ? item.url_online : "");
      //setDuration(item.duration ? item.duration : "");
      setCount(0);
    }
  });

  const changeStart = (e) => {
    setTime(e.target.value);
    setCount(count + 1);
  };

  const changeDuration = (e) => {
    setDuration(e.target.value);
    setCount(count + 1);
  };

  const minusDurationL = () => {
    clickSave(-5);
    //      setCount(count + 1);
  };

  const plusDurationL = () => {
    clickSave(5);
    //      setCount(count + 1);
  };

  const changeUrl = (e) => {
    setUrl(e.target.value);
    setCount(count + 1);
  };

  const onFocusOut = () => {
    if (focus == true) {
      setFocus(false);
      clickSave();
    }
  };

  const onFocusUrlOut = () => {
    if (focusUrl == true) {
      setFocusUrl(false);
      clickSaveUrl();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function clickSave(delta = 0) {
    let newDur = +duration + delta;
    if (newDur < 1) newDur = 1;
    saveTime(item, startTime, newDur);
    //if (delta !=0)
    setDuration(newDur);
    //setCount(0);
  }

  function clickSaveUrl() {
    saveUrl(item, url);
    //setCount(0);
  }

  function onTextChange(e, oldVal) {
    changeThemes(e, oldVal);
    setCount(0);
  }

  function onSpeakerTextChange(e, i) {
    changeSpeakers(e, i);
    setCount(0);
  }

  function onSpeakerPartipChange(e, i) {
    changeSpeakerPartip(e.target.value, i);
    setCount(0);
  }

  function openMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function clickEditTheme() {
    editTheme(item);
  }

  function delSlotL() {
    setAnchorEl(null);
    delSlot();
  }

  function clickEditThemeL() {
    setAnchorEl(null);
    clickEditTheme();
  }

  function moveSlotL() {
    setAnchorEl(null);
    moveSlot(mainIndex, id);
  }

  function unbindSlotL() {
    setAnchorEl(null);
    unbindSlot();
  }

  let itemtype = item.type;

  if (item.entity && item.entity.type) itemtype = item.entity.type;

  return (
    <div className="line-constructor">
      <div className="time">
        <div className="time-value">
          <input
            type="time"
            id="time"
            onBlur={onFocusOut}
            onFocus={() => setFocus(true)}
            onChange={changeStart}
            value={startTime || ""}
            min="00:00"
            max="23:59"
            style={{ width: 110 }}
          />
        </div>
        <FormatIcons
          type={itemtype}
          canChange={true}
          changeMode={() => changeMode(itemtype, item)}
        />
      </div>
      <div className="move" />
      <div className="duration">
        <div className="duration-item">
          <div
            className="minus"
            //onClick={() => minusDuration(mainIndex, index)}
            onClick={minusDurationL}
          >
            <i className="icon-minus" />
          </div>
          <label htmlFor="">
            <input
              type="number"
              id="duration"
              min={1}
              onBlur={onFocusOut}
              onFocus={() => setFocus(true)}
              onChange={changeDuration}
              value={+duration || undefined}
              style={{ height: 50 }}
            />
            <span>минут</span>
          </label>
          <div
            className="pluse"
            //onClick={() => plusDuration(mainIndex, index)}
            onClick={plusDurationL}
          >
            <i className="icon-plus" />
          </div>
        </div>
      </div>
      <div className="theme" style={{ display: "flex", flexDirection: "row" }}>
        <div className="theme-item" style={{ display: "flex", flex: 1 }}>
          <Droppable droppableId={`theme_${mainIndex}_${index}`}>
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="input-wrap"
              >
                <div className="slot_wrapper">
                  {item.slot_type == "lesson" && (
                    <SelectTheme
                      data={themes}
                      item={
                        item.entity && item.entity.name ? item.entity.name : ""
                      }
                      onChange={onTextChange}
                    />
                  )}
                  {!item.slot_type && (
                    <SelectTheme
                      data={themes}
                      item={item.theme ? item.theme : ""}
                      onChange={onTextChange}
                    />
                  )}
                  {item.slot_type == "service_lesson" && (
                    <span>{item.entity != null && item.entity.name}</span>
                  )}
                  
                </div>
              </div>
            )}
          </Droppable>
        </div>
        <div
          title="Удаление слота"
          style={{ marginTop: 10, cursor: "pointer",marginRight:10}}
        >
          {item.slot_type == "service_lesson" && (
                    <DeleteIcon onClick={() => changeThemes(null, "")} />
                  )}
        </div>
        <div
          title="Редактирование темы"
          style={{ marginTop: 10, cursor: "pointer" }}
        >
          {(item.theme || (item.entity && item.entity.name)) && (
            <EditIcon width="15" height="15" onClick={clickEditTheme} />
          )}
        </div>
      </div>
      <div className="speaker">
        {item.slot_type !== "service_lesson" && <SpeakersList
          speakers={
            item.entity && item.entity.speakers ? item.entity.speakers : []
          }
          mainIndex={mainIndex}
          index={index}
          item={item}
          allSpeakers={speakers}
          addSpeaker={addSpeaker}
          onSpeakerTextChange={onSpeakerTextChange}
          onSpeakerPartipChange={onSpeakerPartipChange}
          delSpeaker={delSpeaker}
          showDeclined={showDeclined}
        />}
      </div>
      <div className="room">
        <div className="room-item">
          {(itemtype == "hybrid" || itemtype == "offline" || !itemtype) && (
            <Droppable droppableId={`room_${mainIndex}_${index}`}>
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="input-wrap"
                >
                  <div className="slot_wrapper">
                    <SelectRoom
                      data={rooms}
                      id={item.room_id ? item.room_id : 0}
                      item={item.room ? item.room : ""}
                      onChange={(e) => changeRoom(e, item)}
                    />
                  </div>
                </div>
              )}
            </Droppable>
          )}
          {(itemtype == "hybrid" || itemtype == "online") && (
            <input
              style={{ marginTop: 5 }}
              placeholder="url выступления"
              onBlur={onFocusUrlOut}
              onFocus={() => setFocusUrl(true)}
              onChange={changeUrl}
              value={url}
            />
          )}
        </div>
      </div>
      <div
        className="options"
        style={{ marginTop: 10, marginLeft: 10, width: 40 }}
      >
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={moveSlotL}>Переместить в секцию</MenuItem>
          {mainIndex >= 0 && (
            <MenuItem onClick={unbindSlotL}>Открепить от секции</MenuItem>
          )}
          {(item.theme || (item.entity && item.entity.name)) && (
            <MenuItem onClick={clickEditThemeL}>Редактировать тему</MenuItem>
          )}
          <MenuItem onClick={delSlotL}>Удалить слот</MenuItem>
        </Menu>
        <MoreIcon onClick={openMenu} />
      </div>
    </div>
  );
}
